export const USER_PROJECT_STATUSES = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DISABLED: 'disabled'
};
